import { render, staticRenderFns } from "./newest.vue?vue&type=template&id=489b61a2&scoped=true"
import script from "./newest.vue?vue&type=script&lang=js"
export * from "./newest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489b61a2",
  null
  
)

export default component.exports